// extracted by mini-css-extract-plugin
export default {"timer":"Timer_timer__SB1MU","timer__btn":"Timer_timer__btn__0gCKN"};